import React from 'react'
import { Row, Col, Grid} from 'react-bootstrap';
import { Icon } from 'semantic-ui-react'
import moment from 'moment';
import ReactGA from 'react-ga';



class OSAgencyCard extends React.Component{

    constructor(props){
        super(props)
       
    }

    goToAgency = (url) => { 
        
        let outgoingTrip = JSON.parse(localStorage.getItem('outgoingTrip'));
        let incomingTrip = JSON.parse(localStorage.getItem('incomingTrip'));

            ReactGA.event({
                category: 'Agencies',
                action: 'goAgencyUrl',
                label: `goAgencyUrl#${moment(this.props.sdate).format("YYYYMMDD")}#${moment(outgoingTrip.departureDateTime).format("hhmm")}#${this.props.agencyId}#${this.props.webSiteUrl}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`
            });
            if(incomingTrip){
            ReactGA.event({
                category: 'Agencies',
                action: 'postBookingAgent',
                label: `postBookingAgent#${moment(this.props.sdate).format("YYYYMMDD")}#${moment(outgoingTrip.departureDateTime).format("hhmm")}#${this.props.agencyId}#${outgoingTrip.company.id}#${moment(this.props.sdate).format("YYYYMMDD")}#${moment(this.props.edate).format("YYYYMMDD")}#${outgoingTrip.vessel.id}#${moment(incomingTrip.departureDateTime).format("YYYYMMDD")}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`
            });
          }else{
            ReactGA.event({
                category: 'Agencies',
                action: 'postBookingAgent',
                label: `postBookingAgent#${moment(this.props.sdate).format("YYYYMMDD")}#${moment(outgoingTrip.departureDateTime).format("hhmm")}#${this.props.agencyId}#${outgoingTrip.company.id}#${moment(this.props.sdate).format("YYYYMMDD")}#${moment(this.props.edate).format("YYYYMMDD")}#${outgoingTrip.vessel.id}#2b735297-625f-412f-8bd0-6a6498d494e0#2104675081`
            });
          }
          
        var form = document.createElement("form");

        const BMAgencies = ["7842","6028","8832","9510","8856","6438","6176","9335","3071","9313","9585","7516","5103","5324","5713","8174","9031","8838","1001","6251","8846","9394","9481","5602","9285","6410","1000","5225","7590","8556","5281","2000","8964","5878","5236","6083","6977","7347","9000","8016","7270"];

        let bookingURL = url;
        if(url.toLowerCase().indexOf("npgres.exe") > -1){
            if(BMAgencies.indexOf(this.props.agencyId) > -1){
                if(url.indexOf("PM=BM") === -1){
                    bookingURL = `${bookingURL}BM`;
                }
            }else{
                if(url.indexOf("PM=BM") === -1){
                    bookingURL = `${bookingURL}BO`;
                }
            }
        }
       
        if(url.indexOf("com/app") > -1){
            form.setAttribute("method", "get");  
            form.setAttribute("action", `${url}`);
        }else{
            form.setAttribute("method", "post");
            form.setAttribute("action", `${bookingURL}`);
        form.setAttribute("className", "hiddenForm");
        
        // setting form target to a window named 'formresult'
        form.setAttribute("target", "_blank");
        
        var hiddenField = document.createElement("input");              
        hiddenField.setAttribute("name", "rdfrom");
        hiddenField.setAttribute("value", `${this.props.from}`);
        form.appendChild(hiddenField);

        var hiddenField = document.createElement("input");              
        hiddenField.setAttribute("name", "rdto");
        hiddenField.setAttribute("value", `${this.props.to}`);
        form.appendChild(hiddenField);

        let sdateToPost = moment(this.props.sdate, "YYYY-MM-DD").format("YYYY;MM;DD;")
        var hiddenField = document.createElement("input");              
        hiddenField.setAttribute("name", "rddate");
        hiddenField.setAttribute("value", `${sdateToPost}`);
        form.appendChild(hiddenField);

        if(this.props.sdate !== this.props.edate){
            var hiddenField = document.createElement("input");              
            hiddenField.setAttribute("name", "rdfrom2");
            hiddenField.setAttribute("value", `${this.props.to}`);
            form.appendChild(hiddenField);

            var hiddenField = document.createElement("input");              
            hiddenField.setAttribute("name", "rdto2");
            hiddenField.setAttribute("value", `${this.props.from}`);
            form.appendChild(hiddenField);

            let edateToPost = moment(this.props.edate, "YYYY-MM-DD").format("YYYY;MM;DD;")
            var hiddenField = document.createElement("input");              
            hiddenField.setAttribute("name", "rddate2");
            hiddenField.setAttribute("value", `${edateToPost}`);
            form.appendChild(hiddenField);
        }
        }
        

        document.body.appendChild(form);
        form.submit();

        form.parentNode.removeChild(form);

    }

    render(){

        let refactoredPhone = this.props.tel.replace(new RegExp(",", 'g'), ", ")
    
        return (
            <Row className="TableRow" key={this.props.key}>
                <Col lg={10} md={10} sm={10} xs={10} style={{paddingRight: '0px'}} style={{borderBottom: '0px solid transparent'}}>
    
                    <Col lg={5} md={5} sm={5} xs={12} style={{padding: '0px'}}> 
                        <div className="portName">{this.props.name} / {this.props.address} </div>
                    </Col>
                    <Col className="removePaddingsOnXS" lg={4} md={4} sm={4} xs={12}> 
                        <div className="portName">{refactoredPhone} </div>
                    </Col>
                    <Col lg={3} md={3} sm={3} xs={12} style={{padding: '0px'}}> 
                        <div className="portName">{this.props.fax} </div>
                    </Col>
                </Col>
                <Col lg={2} md={2} sm={2} xs={2} style={{padding: '0px'}}>
                    <Icon onClick={() => this.goToAgency(this.props.url)} style={{ cursor: 'pointer' }} name='ticket' size='big' />
                </Col>
            </Row>
        )
    }

}

export default OSAgencyCard;


// WEBPACK FOOTER //
// ./src/components/OSAgencyCard/OSAgencyCard.js